var map = {
	"./misc": "+nrk",
	"./misc.ts": "+nrk",
	"./numbers": "23eX",
	"./numbers.ts": "23eX",
	"./prismic": "wn01",
	"./prismic.config": "rMRE",
	"./prismic.config.js": "rMRE",
	"./prismic.ts": "wn01",
	"./theme": "FM/7",
	"./theme.ts": "FM/7",
	"./useMediaQuery": "yKX0",
	"./useMediaQuery.ts": "yKX0",
	"./variables": "wi+z",
	"./variables.ts": "wi+z"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Frz+";